module.exports = __webpack_public_path__ + "images/black-friday-promo-banner.png";